// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSingleColumn_root__BBnQy","layoutWrapperMain":"LayoutSingleColumn_layoutWrapperMain__2HtUT"};